import React, { useCallback, useRef, useState, useEffect, Ref } from 'react'
import {
  message,
  Spin,
  TreeSelect,
  Card,
  Avatar,
  Tag,
  Skeleton,
  Timeline,
  Radio,
  Row,
  Col,
  Button,
  Divider,
} from 'antd'
import {
  SBack,
  SLowcodeList,
  SGeneralForms,
  SListTabs,
  STitle,
  SSegmentedTabs,
  SDrawerOrModal,
} from 'shj-components'
import { useNavigate, useParams, useSearchParams, useLocation } from 'react-router-dom'
import dayjs from 'dayjs'
import SelectLabel from '../components/SelectLabel'
import BasicInfo from '@/components/BasicInfo'
import FollowRecord from '@/components/FollowRecord'
import ServiorInfo from '@/components/ServiorInfo'
import OrderInfo from '@/components/OrderInfo'
import avatarNew from '@/assets/avatar-new.png'
import {
  getCustomerMemberInfo,
  getTrackPlanInfo,
  getTrackPlanLog,
  getTrackPlanRelatives,
} from '@/services/customerServices.ts'
import styles from './index.module.less'

const Details = () => {
  const staffRef = useRef()
  const location = useLocation()
  const { id, customerId } = useParams()
  const [isVisible, setIsVisible] = useState(false)
  const [trackPlanReletiveInfo, setTrackPlanReletiveInfo] = useState([])
  const [trackPlanLogInfo, setTrackPlanLogInfo] = useState([])
  const [trackPlanInfo, setTrackPlanInfo] = useState({})
  const [infoChoice, setInfoChoice] = useState('a')
  const [loading, setLoading] = useState(false)
  const [detailsInfo, setDetailsInfo] = useState({
    customerInfo: {},
    memberInfo: {},
  })

  useEffect(() => {
    if (customerId) {
      fetchCustomerMemberInfo(customerId)
    }
    if (id) {
      fetchTrackPlanInfo(id)
      fetchTrackPlanRelatives(id)
      fetchTrackPlanLog(id)
    }
  }, [id, customerId])

  const fetchTrackPlanInfo = async (trackPlanId: any) => {
    try {
      setLoading(true)
      const res: any = (await getTrackPlanInfo(trackPlanId)) || {}
      setLoading(false)
      if (res) {
        setTrackPlanInfo(res)
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const fetchCustomerMemberInfo = async (customerId: any) => {
    try {
      setLoading(true)
      const res: any = (await getCustomerMemberInfo(customerId)) || {}
      setLoading(false)
      if (res) {
        setDetailsInfo(res)
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  // 跟进记录
  const fetchTrackPlanLog = async (trackPlanId: any) => {
    try {
      const res: any = await getTrackPlanLog({ trackPlanId })
      if (res) {
        setTrackPlanLogInfo(res)
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 服务人员
  const fetchTrackPlanRelatives = async (trackPlanId: any) => {
    try {
      const res: any = await getTrackPlanRelatives({ trackPlanId })
      if (res) {
        setTrackPlanReletiveInfo(res)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const changeInfoChoice = (event: any) => {
    setInfoChoice(event?.target?.value)
  }

  return (
    <SBack title={`详情`} level={2} titleStyle={{ position: 'sticky', top: 0, zIndex: 10 }}>
      <div className={styles.detailsMain}>
        <Spin spinning={loading}>
          <Row style={{ marginTop: '5px' }}>
            <Col span={5}>
              <div className={styles.leftInfo}>
                <div className={styles.detailsMainFlex}>
                  <Avatar size={70} src={detailsInfo?.memberInfo?.imageUrl || avatarNew} />
                  <div
                    style={{ marginTop: 10, marginBottom: 15, textAlign: 'center', fontSize: 18 }}
                  >
                    <div>{detailsInfo?.customerInfo?.name}</div>
                    <div>{detailsInfo?.customerInfo?.phone}</div>
                  </div>
                  <Row gutter={[0, 10]}>
                    <Col className="gutter-row" span={24}>
                      <div>
                        <span className={styles.fontColor}>性别：</span>
                        {detailsInfo?.customerInfo?.gender}
                      </div>
                    </Col>
                    <Col className="gutter-row" span={24}>
                      <div>
                        <span className={styles.fontColor}>年龄：</span>
                        {detailsInfo?.customerInfo?.age}
                      </div>
                    </Col>
                    <Col className="gutter-row" span={24}>
                      <div>
                        <span className={styles.fontColor}>生日：</span>
                        {detailsInfo?.customerInfo?.birthday
                          ? dayjs(detailsInfo?.customerInfo?.birthday).format('YYYY-MM-DD')
                          : ''}
                      </div>
                    </Col>
                    <Col className="gutter-row" span={24}>
                      <div>
                        <span className={styles.fontColor}>职业：</span>
                        {detailsInfo?.customerInfo?.careerName}
                      </div>
                    </Col>
                    <Col className="gutter-row" span={24}>
                      <div>
                        <span className={styles.fontColor}>邮箱：</span>
                        {detailsInfo?.customerInfo?.email}
                      </div>
                    </Col>
                  </Row>
                </div>
                {/* 如果该客户是注册会员，则显示该模块信息，如果不是则不显示 */}
                {detailsInfo?.customerInfo?.memberFlag && (
                  <>
                    <Divider style={{ margin: '10px 0' }} />
                    <div className={styles.flexBetween}>会员信息</div>
                    <div style={{ marginTop: 15 }}>
                      <Row gutter={[0, 10]}>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>会员ID：</span>
                            {detailsInfo?.memberInfo?.id}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>会员名称：</span>
                            {detailsInfo?.memberInfo?.name}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>会员积分：</span>
                            {detailsInfo?.memberInfo?.integralValue}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>会员成长值：</span>
                            {detailsInfo?.memberInfo?.growValue}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>会员等级：</span>
                            {detailsInfo?.memberInfo?.levelName}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>最近访问时间：</span>
                            {detailsInfo?.memberInfo?.lastLoginTime
                              ? dayjs(detailsInfo?.memberInfo?.lastLoginTime).format('YYYY-MM-DD HH:mm:ss')
                              : ''}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>入会时间：</span>
                            {detailsInfo?.memberInfo?.createdTime
                              ? dayjs(detailsInfo?.memberInfo?.createdTime).format('YYYY-MM-DD HH:mm:ss')
                              : ''}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </>
                )}
              </div>
            </Col>
            <Col span={19}>
              <div className={styles.rightInfo}>
                <div className={styles.follow}>
                  <div className={styles.followUp}>
                    <div className={styles.followStart}>
                      <div style={{ paddingRight: 30 }}>
                        楼盘：{trackPlanInfo?.houseInfo?.buildingName}
                      </div>
                      <div style={{ paddingRight: 30 }}>
                        跟进门店：{trackPlanInfo?.houseInfo?.orgName}
                      </div>
                      {location?.state?.statusName && (
                        <Tag color="blue">{location?.state?.statusName}</Tag>
                      )}
                    </div>
                    <div>
                      {trackPlanInfo?.lastFollowTime
                        ? dayjs(trackPlanInfo?.lastFollowTime).format('YYYY-MM-DD HH:mm:ss')
                        : ''}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginTop: 20,
                    }}
                  >
                    <Radio.Group
                      defaultValue={infoChoice}
                      buttonStyle="solid"
                      onChange={changeInfoChoice}
                    >
                      <Radio.Button value="a">基本信息</Radio.Button>
                      <Radio.Button value="b">跟进记录</Radio.Button>
                      <Radio.Button value="c">服务人员</Radio.Button>
                      <Radio.Button value="d">订单信息</Radio.Button>
                    </Radio.Group>
                  </div>
                  {infoChoice === 'a' && <BasicInfo basicInfo={trackPlanInfo} editTag={false} />}
                  {infoChoice === 'b' && <FollowRecord basicInfo={trackPlanLogInfo} />}
                  {infoChoice === 'c' && (
                    <ServiorInfo basicInfo={trackPlanReletiveInfo} hidden={true} />
                  )}
                  {infoChoice === 'd' && <OrderInfo editId={id} />}
                </div>
              </div>
            </Col>
          </Row>
        </Spin>
        {isVisible ? (
          <SelectLabel
            open={isVisible}
            rest={{ id: 1 }}
            onClose={() => {
              setIsVisible(false)
            }}
            fn={() => console.log('测试')}
          />
        ) : null}
      </div>
    </SBack>
  )
}
export default props => {
  return <Details {...props} />
}
